import type { ExplorerPlatformIconKey } from 'src/constants/mindtime/explorerInstallers';
import windowsIcon from './windows.svg';
import macosIcon from './macos.svg';
import synologyIcon from './synology.svg';
import qnapIcon from './qnap.svg';
import linuxDebIcon from './linux-deb.svg';
import linuxRpmIcon from './linux-rpm.svg';
import linuxShIcon from './linux.svg';
import pcBackupLogo from './MT-logo-pc-backup.svg';
import proBackupLogo from './MT-logo-pro-backup.svg';
import vmBackupLogo from './MT-logo-vm-backup.svg';

export type ExplorerProductLogoKey = 'pcBackup' | 'proBackup' | 'vmBackup';

const iconBox = { width: 28, height: 28, display: 'block' as const };
const productLogoBox = { width: 25, height: 25, display: 'block' as const };

const PLATFORM_ICON_SRC: Record<ExplorerPlatformIconKey, string> = {
  windows: windowsIcon,
  macos: macosIcon,
  synology: synologyIcon,
  qnap: qnapIcon,
  ubuntu: linuxDebIcon,
  linuxRpm: linuxRpmIcon,
  linuxSh: linuxShIcon,
};

const PRODUCT_LOGO_SRC: Record<ExplorerProductLogoKey, string> = {
  pcBackup: pcBackupLogo,
  proBackup: proBackupLogo,
  vmBackup: vmBackupLogo,
};

export function ExplorerPlatformIcon({ platform }: { platform: ExplorerPlatformIconKey }) {
  return (
    <img
      src={PLATFORM_ICON_SRC[platform]}
      alt=""
      width={28}
      height={28}
      style={iconBox}
      aria-hidden
    />
  );
}

export function ExplorerProductLogo({ product }: { product: ExplorerProductLogoKey }) {
  return (
    <img
      src={PRODUCT_LOGO_SRC[product]}
      alt=""
      width={25}
      height={25}
      style={productLogoBox}
      aria-hidden
    />
  );
}
